export const COST_TYPE_MONETARY = 'monetary';
export const COST_TYPE_PERCENTAGE = 'percentage';
export const TARGET_ENTITIES = {
  funds: 'funds',
  submissionRequests: 'submission-requests',
  associateUsers: 'associate-users',
  costAnalysis: 'cost-analysis',
  pensionSchemes: 'pension-schemes',
  reports: 'reports',
  subFunds: 'sub-funds',
  users: 'users'
};
export const LOGIN_MODES = {
  password: 'password',
  emailOtp: 'emailOtp',
  emailLink: 'emailLink'
};
export const KEY_CODES = {
  backspace: 8,
  leftArrow: 37,
  rightArrow: 39,
  delete: 46
};
export const TEMPLATE_SOURCE = {
  platform: 'cg_platform',
  platformWithImpersonation: 'cg_platform_with_impersonation'
};
export const PASSWORD_HINT =
  'Your password must be at least 8 characters long and include at' +
  ' least one uppercase letter,one lowercase letter, one special character(like ! and $) and a number';
export const LOGIN_ROUTE = 'auth.login';

export const LOGIN_ROUTES = [
  LOGIN_ROUTE,
  'auth.unlock.account',
  'auth.twoFactorAuth',
  'auth.one-time-password'
];

export const FUND_NATURES_SLUG = {
  PORTFOLIO: 'portfolio',
  WRAPPER: 'wrapper',
  SUBFUND: 'sub-fund',
  FUND: 'fund'
};

export enum QC_STATUS {
  NEED_RESOLUTION = 'NEED_RESOLUTION'
}
